<template>
  <v-container fluid>
    <v-layout row wrap fluid class="d-flex mx-auto">
      <v-flex xs12 pa-5 pb-0>
        <p class="title primary--text font-weight-medium">ข้อมูลอุบัติเหตุซ้ำ</p>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 pa-5 pt-0>
        <v-data-table
          :headers="reportHeader"
          :items="reportData"
          :items-per-page="-1"
          no-data-text="ไม่พบข้อมูล"
          class="elevation-0 mt-0"
          hide-default-footer
          :mobile-breakpoint="0"
          :fixed-header="true"
        >
          <template v-slot:item="props">
            <tr>
              <td class="content-data primary--text font-weight-medium">{{ props.item.name }}</td>
              <template v-for="(val, index) in props.item.value">
                <td v-if="props.item.attr == 'accident_code'" class="content-data text-wrap">
                  <a :href="'/report_detail?data=' + val">{{ val }}</a>
                </td>
                <td v-else class="content-data text-wrap">{{ val }}</td>
              </template>
            </tr>
          </template>
        </v-data-table>
        <v-divider color="#4F3F40" class="mt-5"></v-divider>
        <v-row v-if="['ADMIN', 'SYSTEM'].indexOf(role) != -1">
          <v-checkbox
            class="mx-auto"
            v-model="checked"
            :disabled="isLoading"
            label="ตรวจสอบแล้ว"
            @change="setValidate(checked)"
          ></v-checkbox>
        </v-row>
        <v-row v-else>
          <div class="mx-auto mt-3 mb-1">
            <span class="primary--text font-weight-medium mr-2">สถานะ:</span>
            <span>{{ checked ? 'ตรวจสอบแล้ว' : 'ยังไม่แก้ไข' }}</span>
          </div>
        </v-row>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <AlertDialog v-model="alertDialog" v-on:ok-btn-click="alertDialogOkClicked" status="error"
          ><span style="white-space: pre;"> {{ alertDialogMessage }}</span></AlertDialog
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import cloneDeep from 'clone-deep';
import AlertDialog from '../global/AlertDialog';

const qs = require('qs');

export default {
  name: 'EditReport',
  components: {
    AlertDialog
  },
  props: {},
  data: () => ({
    reportData: [
      {
        name: 'เลขอุบัติเหตุ',
        attr: 'accident_code',
        value: []
      },
      {
        name: 'วันที่เกิดเหตุ',
        attr: 'accident_date',
        value: []
      },
      {
        name: 'เวลาที่เกิดเหตุ',
        attr: 'accident_time',
        value: []
      },
      {
        name: 'หมายเลขสายทาง',
        attr: 'route_code',
        value: []
      },
      {
        name: 'กิโลเมตรที่',
        attr: 'km',
        value: []
      },
      {
        name: 'ชื่อสายทาง',
        attr: 'route_name',
        value: []
      },
      {
        name: 'ที่อยู่',
        attr: 'address',
        value: []
      },
      {
        name: 'จำนวนผู้บาดเจ็บ',
        attr: 'injured',
        value: []
      },
      {
        name: 'จำนวนผู้เสียชีวิต',
        attr: 'dead',
        value: []
      }
    ],
    reportHeader: [],
    checked: false,
    isLoading: false,
    alertDialog: false,
    alertDialogMessage: '',
    role: localStorage.getItem('role')
  }),
  mounted() {
    this.initReportData();
  },
  methods: {
    initReportData() {
      const { query } = this.$route;
      this.reportHeader.push({
        text: ' ',
        align: 'center',
        sortable: false,
        value: 'title',
        width: '25%'
      });
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/duplicate/accident_by_id/${query.data}`;
      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200) {
            let maxVehicle = 0;
            const result = response.data.data;
            scope.checked = false;
            result.forEach((data, index) => {
              scope.reportHeader.push({
                text: `${data.department}`,
                align: 'center',
                sortable: false,
                value: `department_${index}`,
                width: `${75 / result.length}%`
              });
              scope.checked = data.checked;
              maxVehicle = Math.max(maxVehicle, data.registration_number.length);
            });
            for (let i = 1; i <= maxVehicle; i++) {
              scope.reportData.push({
                name: `ทะเบียนยานพาหนะ คันที่ ${i}`,
                attr: `registration_number_${i}`,
                value: []
              });
            }
            scope.reportData = scope.reportData.map(item => {
              result.forEach((data, index) => {
                if (item.attr == 'address') {
                  const address = [data.tambon, data.amphoe, data.province]
                    .filter(el => el)
                    .join(', ');
                  item.value.push(address.length ? address : '-');
                } else if (item.attr.indexOf('registration_number') != -1) {
                  if (item.attr.substr(20) <= data.registration_number.length) {
                    item.value.push(data.registration_number[item.attr.substr(20) - 1]);
                  } else {
                    item.value.push('-');
                  }
                } else {
                  item.value.push(data[item.attr]);
                }
              });
              return item;
            });
          }
        })
        .catch(function(error) {
          const { response } = error;
          if (response.status === 401) {
            console.log('unauthorized');
            scope.$router.push({ name: 'unauthorized' });
          } else {
            console.log(error);
          }
        });
    },
    setValidate(checked) {
      const { lat } = location;
      const { lon } = location;
      const scope = this;
      const { query } = this.$route;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/set/duplicate/validate/${query.data}`;
      const data = { validate: checked };
      this.isLoading = true;
      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          // if (response.status == 200) {
          //   console.log(response);
          // }
          scope.isLoading = false;
        })
        .catch(function(error) {
          console.log(error);
          scope.isLoading = false;
          scope.checked = !checked;
          scope.setupAlertDialog('ไม่สามารถบันทึกข้อมูลได้');
        });
    },
    setupAlertDialog(message) {
      this.alertDialog = true;
      this.alertDialogMessage = message;
      this.hideIcon = false;
    },
    alertDialogOkClicked() {
      this.alertDialog = false;
    }
  },
  computed: {},
  watch: {
    // reportId(val) {
    // console.log(val);
    // }
  }
};
</script>
<style lang="scss" scoped>
.normal-line-height {
  line-height: normal !important;
}
.content-data {
  width: max-content;
  white-space: nowrap;
  text-align: center;
}
::v-deep #dense-table.v-data-table table {
  width: fit-content;
}
tr,
td {
  border: 0 !important;
}
::v-deep th {
  border-bottom-color: #4f3f40 !important;
}
.v-btn:before:focus {
  background-color: transparent;
  opacity: 1;
}
</style>
